import { combineReducers } from 'redux';

import commonReducers from '../../common/reducers';
import feedSEOTags from './feed-seo-tags';
import lastFeaturedPost from './last-featured-post';

export default combineReducers({
  ...commonReducers,
  lastFeaturedPost,
  feedSEOTags,
});
